var map = {
	"./mask-1.png": "NI+b",
	"./mask-2.png": "z6Ex"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/hYU";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter ^\.\/mask\-.*\.png$
// module id = /hYU
// module chunks = 1